export const useCurrentDealerId = () =>
  sessionStorage.getItem("currentDealerId");
